// extracted by mini-css-extract-plugin
module.exports = {"AddService":"AddService_JnpzK","AddServiceModalCIDRIcon":"AddServiceModalCIDRIcon_ZD7gi","AddServiceVersions":"AddServiceVersions_w0x9M"};